import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import { getInputFields } from 'app/developer-v3/utils';
import {
  currentAppEntity,
  currentSelectedApi,
} from 'app/developer-v3/selectors';

import EditorPreview from './EditorPreview';

const mapStateToProps = (state, props) => {
  const appEntity = currentAppEntity(state);

  return {
    selectedApi: currentSelectedApi(state),
    appName: CliApp.selectors.title(appEntity),
    appLogoUrl: CliApp.selectors.imageUrl(appEntity),
    appStatus: CliApp.selectors.status(appEntity),
    inputFields: getInputFields(props.service),
  };
};

export default connect(mapStateToProps)(EditorPreview);
